export enum StatusCategoryId {
  Open = 1,
  Closed = 2,
}

export class DashboardInvestigationRowEntity {
  public id!: string;
  public investigationNumber!: string;
  public investigationTypeName!: string;
  public investigationTypeCategoryName!: string;
  public requestorName!: string;
  public statusName!: string;
  public statusDisplayName!: string;
  public statusColor!: string;
  public statusCategoryId!: StatusCategoryId;
  public statusCategoryName!: string | null;
  public isReadOnly!: boolean;
  public priorityCode!: string;
  public primaryAssigneeUserId!: string | null;
  public primaryAssigneeName!: string | null;
  public secondaryAssigneeUserId!: string | null;
  public secondaryAssigneeName!: string | null;
  public assignedTeamId!: string | null;
  public assignedTeamName!: string | null;
  public requestorEmail!: string | null;
  public requestorDepartment!: string | null;
  public requestorDivision!: string | null;
  public createdByUserId!: string;
  public createdByName!: string | null;
  public updatedByUserId!: string | null;
  public updatedByName!: string | null;
  public createdOn!: string;
  public updatedOn!: string;
  public dueDate!: string | null;
  public slaStatus!: string;
  public unreadMessageCount!: number;
  public hasMessages!: boolean;
  public isCurrentUserWatching!: boolean;
  public requestedByUserId!: string;
  public excludedAssigneeUserIds!: string[];
}
